export function createContentCollection(modules, basePath, order = []) {
  const itemsMap = Object.fromEntries(
    Object.entries(modules).map(([path, module]) => {
      const slug = path.replace(basePath, '').replace('.mdx', '')
      return [slug, {
        slug,
        title: module?.title,
        description: module?.description,
        linkUrl: module?.linkUrl,
        linkLabel: module?.linkLabel,
        linkIcon: module?.linkIcon,
      }]
    })
  )

  // Use manual order if provided, otherwise return items in any order
  const items = order.length > 0
    ? order.map(slug => itemsMap[slug]).filter(Boolean)
    : Object.values(itemsMap)

  const getBySlug = (slug) => itemsMap[slug]

  return { items, getBySlug }
}
